








































































import Vue from 'vue';


export default Vue.extend({
  name: 'contact-form',
  data () {
    return {
      submitButtonText: 'Send Message',
      processingForm: false,
      processFormError: false,
      form: {
        fullname: '',
        email: '',
        contactnumber: '',
        comment: '',
      },
    };
  },
  methods: {
    clearFormFields () {
      this.form.fullname = '';
      this.form.email = '';
      this.form.contactnumber = '';
      this.form.comment = '';
    },
    encode (data: any) {
      return Object.keys(data)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
    },
    async handleSubmit () {
      const headers = {'Content-Type': 'application/x-www-form-urlencoded'};

      this.processingForm = true;
      this.submitButtonText = 'Sending';

      fetch('/', {
        method: 'post',
        headers,
        body: this.encode({
          'form-name': 'contactme',
          ...this.form,
        }),
      }).then(() => {
        this.processingForm = false;
        this.submitButtonText = 'Message Sent';

        this.clearFormFields();
      }).catch(() => {
        this.processingForm = false;
        this.processFormError = true;
        this.submitButtonText = 'Submit';

        this.clearFormFields();
      });
    },
  },
});
